import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.293 18c.075-.005.095-.005.17-.018a1.23 1.23 0 0 0 .671-.358l7.5-7.714c.053-.057.067-.07.113-.133q.078-.105.133-.224a1.33 1.33 0 0 0-.133-1.33c-.046-.062-.06-.075-.112-.132L2.135.377C2.078.323 2.065.308 2.004.26A1.24 1.24 0 0 0 1.038.02q-.17.03-.325.106c-.39.19-.662.587-.706 1.03a1.33 1.33 0 0 0 .247.908c.046.062.06.075.112.132L6.983 9 .366 15.806l-.058.064c-.048.06-.062.075-.103.14a1.3 1.3 0 0 0-.204.749c.014.444.26.859.636 1.077q.188.108.4.146c.076.013.095.013.17.018z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }